import { render, staticRenderFns } from "./DialogoBuscar.vue?vue&type=template&id=70ec927b&scoped=true&"
import script from "./DialogoBuscar.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec927b",
  null
  
)

export default component.exports